const PencapaianIndikatorSearch = {
    idSekolah: null,
    idProfil: null,
    idSubProfil: null,
    idSiswa: null,
    idKelasParalel: null,
    kodeTahunAjaran: null
};

export default PencapaianIndikatorSearch;